// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-path.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/arrow-path'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowPathIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
